<template>
  <div>
    <m-layout-grid v-show="uiList.isShowed" class="app-layout-grid--content">
      <app-layout-grid-inner-custom class="app-inmuebles-list__filter-simple">
        <m-layout-grid-cell :span-phone="4" :span-tablet="8" :span-desktop="12">
          <m-chip-set>
            <m-chip
              v-for="(filterChip, index) in uiFilterChips.chips"
              :key="index"
            >
              {{ formatFilterChipValue2ChipText(index, filterChip.value) }}
              <m-icon
                icon="clear"
                slot="trailingIcon"
                @click="uiFilterChips.onChipRemoved(index)"
              />
            </m-chip>
          </m-chip-set>
          <m-button
            :outlined="!isFilterFullOpened"
            :raised="isFilterFullOpened"
            @click="isFilterFullOpened = !isFilterFullOpened"
          >
            <m-icon slot="icon" icon="filter_list" />{{
              isFilterFullOpened ? "Menos filtros" : "Más filtros"
            }}</m-button
          >
        </m-layout-grid-cell>
        <!-- <m-layout-grid-cell :span-phone="4" :span-tablet="3" :span-desktop="3">
          <div class="app-inmuebles-list__filter-simple__ver-en-mapa">
            <m-switch id="switch-ver-mapa"></m-switch
            ><label for="switch-ver-mapa">Ver en el mapa</label>
          </div>
        </m-layout-grid-cell> -->
      </app-layout-grid-inner-custom>
      <transition name="transition-fade">
        <app-layout-grid-inner-custom
          v-if="isFilterFullOpened"
          class="app-inmuebles-list__filter-full"
        >
          <m-layout-grid-cell :span="12">
            <app-inmuebles-list-filter-full
              :ap-filter="list.options.filterTerms"
              v-on:filterApplied="onFilterFullApplied"
            >
            </app-inmuebles-list-filter-full>
          </m-layout-grid-cell>
        </app-layout-grid-inner-custom>
      </transition>
      <app-layout-grid-inner-custom
        class="app-inmuebles-list__results"
        :v-if="uiIsThereData2Show"
      >
        <m-layout-grid-cell
          :span-phone="4"
          :span-tablet="8"
          :span-desktop="12"
          class="app-inmuebles-list__results__title"
        >
          <span v-if="uiList.isLoading" class="blinking"
            >Buscando inmuebles...</span
          >
          <span v-if="!uiList.isLoading">
            {{ list.options.totalResultsNumber }}
            {{
              list.options.totalResultsNumber !== 0
                ? "Inmuebles encontrados"
                : "Inmueble encontrado"
            }}
          </span>
        </m-layout-grid-cell>
        <!-- list -->
        <m-layout-grid-cell :span-phone="4" :span-tablet="8" :span-desktop="5">
          <m-layout-grid style="padding:0">
            <m-layout-grid-inner>
              <m-layout-grid-cell
                :span-phone="4"
                :span-tablet="4"
                :span-desktop="12"
                v-for="(item, index) in list.rows"
                :key="index"
              >
                <app-inmuebles-list-item
                  :ap-item="item"
                  v-on:listItemClicked="onListItemClicked(item)"
                />
              </m-layout-grid-cell>
              <m-layout-grid-cell
                :span-phone="4"
                :span-tablet="8"
                :span-desktop="12"
                class="app-inmuebles-list__results__pagination"
                v-if="uiIsThereData2Show"
              >
                <div class="app-inmuebles-list__results__pagination__buttons">
                  <m-icon-button
                    icon="arrow_back_ios"
                    slot="navigation"
                    :disabled="uiListPagination.prevButtonDisabled"
                    @click="uiListPagination.onPrevPageNumberClick()"
                    class="app-icon-button--pagination-arrow"
                  >
                  </m-icon-button>

                  <template v-if="uiListPagination.isThereTooManyPrevPages">
                    <m-icon-button
                      :class="uiListPagination.firstPageNumber.class"
                      :disabled="uiListPagination.firstPageNumber.isCurrent"
                      @click="
                        uiListPagination.onPageNumberClick(
                          uiListPagination.firstPageNumber.number
                        )
                      "
                      >{{ uiListPagination.firstPageNumber.number }}
                    </m-icon-button>
                    <span> ... </span>
                  </template>

                  <!-- page numbers -->
                  <m-icon-button
                    v-for="(pageNumber, index) in uiListPagination.pageNumbers"
                    :key="index"
                    :class="pageNumber.class"
                    :disabled="pageNumber.isCurrent"
                    @click="
                      uiListPagination.onPageNumberClick(pageNumber.number)
                    "
                    >{{ pageNumber.number }}</m-icon-button
                  >

                  <template v-if="uiListPagination.isThereTooManyNextPages">
                    <span> ... </span>
                    <m-icon-button
                      :class="uiListPagination.lastPageNumber.class"
                      :disabled="uiListPagination.lastPageNumber.isCurrent"
                      @click="
                        uiListPagination.onPageNumberClick(
                          uiListPagination.lastPageNumber.number
                        )
                      "
                      >{{ uiListPagination.lastPageNumber.number }}
                    </m-icon-button>
                  </template>
                  <m-icon-button
                    icon="arrow_forward_ios"
                    slot="navigation"
                    :disabled="uiListPagination.nextButtonDisabled"
                    @click="uiListPagination.onNextPageNumberClick()"
                    class="app-icon-button--pagination-arrow"
                  />
                </div>
              </m-layout-grid-cell>
            </m-layout-grid-inner>
          </m-layout-grid>
        </m-layout-grid-cell>

        <!-- mapita resultados-->
        <m-layout-grid-cell :span-phone="4" :span-tablet="8" :span-desktop="7">
          <div
            v-if="!map.showMap"
            style="width: 100%; height: 535px; display:flex;justify-content:center;align-items:center;"
          >
            <div class="blinking" style="font-weight: bold;">
              Generando mapa ...
            </div>
          </div>
          <transition name="transition-fade">
            <app-mapa-inmuebles
              v-if="map.showMap"
              ap-map-id="mapa-listado"
              :apRefGeograficasArray="map.refsGeograficas"
              ap-style="width: 100%; height: 535px; margin-bottom: 3em"
              v-on:mapMarkerClicked="onMapMarkerClicked"
            >
              <!-- height: calc(100% - 74px);" -->
            </app-mapa-inmuebles>
          </transition>
        </m-layout-grid-cell>
      </app-layout-grid-inner-custom>
    </m-layout-grid>
  </div>
</template>

<script>
// Para escuchar al componente de buesqueda global
import AppEventBus from "@/components/AppEventBus.js";
import AppMixinAnalytics from "@/components/AppMixinAnalytics.js";

export default {
  name: "inmuebles-list",
  props: {
    prevListData: { type: Object }, // Indica que ya hay datos que cargar de antes (no hace falta ir a b.d.)
    prevMapData: { type: Object }
  },
  mixins: [AppMixinAnalytics],
  data() {
    return {
      chip1: null,
      chip2: null,
      chipset: null,
      isFilterFullOpened: false,
      defaultListOptions: {
        paginationCurrentPage: 1,
        paginationResultsPerPage: 4,
        sortFieldName: "codprinexpromo",
        sortOrder: "asc",
        totalResultsNumber: null,
        filterTerms: {
          PROVINCIA: { op: "=", value: "JAEN" },
          TIPO_BIEN: { op: "=", value: "SUELO INDUSTRIAL" },
          TIPO_OFERTA: { op: "=", value: "OFERTA PÚBLICA PERMANENTE" }
        },
        fixedFilterTerms: {
          TIPO_OFERTA: { op: "=", value: "OFERTA PÚBLICA PERMANENTE" }
        },
        paginationOptions: [10, 25, 50]
      },
      /**
       * Estructura interna para el estado del componente
       * @type {Object}
       *   list: {
            options: {Poner routes bien
              sortFieldName: "codprinexpromo",
              sortOrder: "asc",
              totalResultsNumber: null,
              filterTerms: {
                PROVINCIA: { op: "=", value: "JAEN" },
                TIPO_BIEN: { op: "=", value: "SUELO INDUSTRIAL" },
                TIPO_OFERTA: { op: "=", value: "OFERTA PÚBLICA PERMANENTE" }
              },
              fixedFilterTerms: {
                TIPO_OFERTA: { op: "=", value: "OFERTA PÚBLICA PERMANENTE" }
              },
              paginationOptions: [10, 25, 50]
            },
            rows: []
          }
       */
      list: {
        dataResourceName: "inmuebles",
        options: {
          paginationCurrentPage: null,
          paginationResultsPerPage: null,
          fullTextSearch: null,
          sortFieldName: null,
          sortOrder: null,
          totalResultsNumber: null,
          filterTerms: {},
          fixedFilterTerms: {}
        },
        rows: []
        // searchByFullTextSearch: this.searchByFullTextSearch,
        // searchByFilterTerms: this.searchByFilterTerms,
        // // Hay que pasar el método onSortChanged porque se cambia en la etiqueta de md-table y la etiqueta de md-table está
        // // en md-content-body porque antes del md-table hay que poner la cabecera con el titulo y demás
        // onSortChanged: this.onSortChanged
      },
      map: {
        dataResourceName: "inmuebles",
        refsGeograficas: [],
        showMap: false
      },
      uiList: {
        isLoading: false,
        isShowed: true
      },
      uiDetail: {
        isShowed: false,
        data: null
      }
    };
  },
  computed: {
    /**
     * Asegura que hay datos cargados para enseñar,
     * se usa para evitar que se muestren cosas hasta que esté cargado algo de datos
     */
    uiIsThereData2Show() {
      return (
        this.list &&
        this.list.rows &&
        this.list.rows.length &&
        this.list.rows.length > 0 &&
        this.list.options.totalResultsNumber &&
        this.list.options.paginationCurrentPage >= 0
      );
    },
    uiFilterChips() {
      // if (!this.list.options.filterTerms) {
      //   // Si no hay terminos nos salimos para evitar errores
      //   return false;
      // }

      var self = this;
      var dataListFilterTerms = this.$mdApp.utils.cloneObject(
        this.list.options.filterTerms
      );
      var onChipRemoved = function(fieldName) {
        self.onChipFilterTermDeleted(fieldName);
      };

      return {
        chips: dataListFilterTerms,
        onChipRemoved: onChipRemoved
      };
    },
    uiListPagination() {
      if (!this.uiIsThereData2Show) {
        // Si no hay datos nos salimos para evitar errores de nulos y eso
        return false;
      }

      var self = this;
      var dataListOptions = this.list.options;

      var totalNumberOfPages = Math.ceil(
        dataListOptions.totalResultsNumber /
          dataListOptions.paginationResultsPerPage
      );
      var pageNumbersShowed = 1; // la "current" y dos por cada lado
      var currentPageNumber = dataListOptions.paginationCurrentPage;
      var isThereTooManyPrevPages =
        currentPageNumber - (pageNumbersShowed - 1) / 2 > 2; // la firstpage siempre está, hay que quitarla de la cuenta
      var isThereTooManyNextPages =
        currentPageNumber + (pageNumbersShowed - 1) / 2 <
        totalNumberOfPages - 1; // la lastpage siempre está, hay que quitarla de la cuenta
      var pageNumbers = [];
      var firstPageNumber = null;
      var lastPageNumber = null;

      if (isThereTooManyPrevPages) {
        firstPageNumber = {
          isCurrent: dataListOptions.paginationCurrentPage === 1,
          class: {
            "app-icon-button--number": true,
            "app-icon-button--number--current":
              dataListOptions.paginationCurrentPage === 1
          },
          number: 1
        };
      }

      var startPageNumber = !isThereTooManyPrevPages
        ? 1
        : currentPageNumber - (pageNumbersShowed - 1) / 2;

      var endPageNumber = !isThereTooManyNextPages
        ? totalNumberOfPages
        : currentPageNumber + (pageNumbersShowed - 1) / 2;

      for (
        var pageNumber = startPageNumber;
        pageNumber <= endPageNumber;
        pageNumber++
      ) {
        pageNumbers.push({
          isCurrent: pageNumber === dataListOptions.paginationCurrentPage,
          class: {
            "app-icon-button--number": true,
            "app-icon-button--number--current":
              dataListOptions.paginationCurrentPage === pageNumber
          },
          number: pageNumber
        });
      }

      // Si hay demasiadas páginas se muestra la última aparte (no hace falta hacer todos los pageNumber)
      if (isThereTooManyNextPages) {
        lastPageNumber = {
          isCurrent:
            totalNumberOfPages === dataListOptions.paginationCurrentPage,
          class: {
            "app-icon-button--number": true,
            "app-icon-button--number--current":
              dataListOptions.paginationCurrentPage === totalNumberOfPages
          },
          number: totalNumberOfPages
        };
      }

      var onPageNumberClick = function(newPageNumber) {
        self.sendAnalyticsEventWithQueryInfo(
          "click_en_paginacion_listado",
          self.$route.query
        );

        self.onListPaginationChanged({
          page: newPageNumber,
          size: self.list.options.paginationResultsPerPage
        });
      };

      var onPrevPageNumberClick = function() {
        onPageNumberClick(self.list.options.paginationCurrentPage - 1);
      };

      var onNextPageNumberClick = function() {
        onPageNumberClick(self.list.options.paginationCurrentPage + 1);
      };

      var result = {
        prevButtonDisabled: dataListOptions.paginationCurrentPage === 1,
        nextButtonDisabled:
          dataListOptions.paginationCurrentPage === totalNumberOfPages,
        pageNumbers: pageNumbers,
        isThereTooManyPrevPages: isThereTooManyPrevPages,
        firstPageNumber: firstPageNumber,
        isThereTooManyNextPages: isThereTooManyNextPages,
        lastPageNumber: lastPageNumber,
        onPageNumberClick: onPageNumberClick,
        onPrevPageNumberClick: onPrevPageNumberClick,
        onNextPageNumberClick: onNextPageNumberClick
      };

      return result;
    }
  },
  mounted() {
    var self = this;

    // Nos ponemos a "escuchar" si envia el componente de busqueda global un evento
    AppEventBus.$on("searchFullSubmitted", function(payLoad) {
      var searchFullText = payLoad;
      self.onFullSearchSubmitted(searchFullText);
    });
  },
  watch: {
    // Esto hay q ue detectarlo para cuando cambia en el mismo route pero si los parametros
    $route() {
      this.initViewFirstTime();
    }
  },
  // Para actualice los datos al terminar el cambio de ruta
  // lo hacemos así en vez de con mounted porque es más flexible y coge más casos,
  // p.e. cuando viene del detalle y éste nos pasa los datos que ya tenía cargados antes
  // para no perder la paginacion ni tneer que cargar los datos
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.prevListData && !vm.prevMapData) {
        vm.initViewFirstTime();
      } else {
        (vm.list = vm.prevListData), (vm.map = vm.prevMapData);
      }
    });
  },
  methods: {
    isEqualQueryParams2FilterTerms(queryParams, filterTerms) {
      var isEqual = true;
      var oldQueryParams = this.filterTerms2queryParams(filterTerms);

      // Si tienen dif numero de params no son iguales
      if (
        Object.entries(oldQueryParams).length !==
        Object.entries(queryParams).length
      ) {
        isEqual = false;
      }

      // Si hay algun valor que no coincida ya no son iguales
      Object.entries(oldQueryParams).forEach(([key, value]) => {
        if (!(queryParams[key] && queryParams[key] === value)) {
          isEqual = false;
        }
      });
      return isEqual;
    },
    initViewFirstTime() {
      // (old-vuemat) this.updateListFixedTermsWithProp();
      // this.updateListFilterTerms(this.defaultListOptions.filterTerms);
      this.updateListFilterTerms(this.queryParams2FilterTerms());
      // this.list.options.fullTextSearch = this.mdFullTextSearch;
      this.updateListPaginationWithDefaultOptions();

      this.updateDataListWithExternalData();
      this.updateMapWithExternalData();

      var busquedaTexto = "";

      if (this.$route.query.busqueda) {
        busquedaTexto = this.$route.query.busqueda;
      } else if (this.$route.query.BUSQUEDA) {
        busquedaTexto = this.$route.query.BUSQUEDA;
      }

      if (busquedaTexto) {
        this.sendAnalyticsEventWithQueryInfo(
          "busqueda_realizada_con_texto",
          this.$route.query
        );
      } else {
        // Vienes con parametros
        this.sendAnalyticsEventWithQueryInfo(
          "busqueda_realizada_con_filtros",
          this.$route.query
        );
      }
    },
    formatFilterChipValue2ChipText(termName, termValue) {
      var text = termValue;

      switch (termName) {
        case "OFERTA":
          text = termValue && termValue === "S" ? "en venta" : "consultar";
          break;
        case "PROMOCION":
          text = termValue ? "denominación: " + termValue.toLowerCase() : "";
          break;
        case "MUTILESMIN":
          text = termValue ? "m² útiles > " + termValue : "m² útiles > 0";
          break;
        case "MUTILESMAX":
          text = termValue ? "m² útiles < " + termValue : "";
          break;
        case "MCONSTRUIDOSMIN":
          text = termValue ? "m² constr. > " + termValue : "m² constr. > 0";
          break;
        case "MCONSTRUIDOSMAX":
          text = termValue ? "m² constr. < " + termValue : "";
          break;
        case "REFERENCIA":
          text = termValue ? "referencia: " + termValue.toLowerCase() : "";
          break;
        case "BUSQUEDA":
          text = termValue ? "busqueda: " + termValue.toLowerCase() : "";
          break;
        case "VIDEO":
          text = termValue ? "con video promocional" : null;
          break;
        case "FICHA":
          text = termValue ? "con ficha promocional" : null;
          break;
        default:
          text = termValue.toLowerCase();
      }

      return text;
    },
    onListItemClicked(itemClicked) {
      // this.uiList.isShowed = false;
      this.uiDetail.data = itemClicked; // como ya está cargado, lo pasamos (no se carga desde b.d)

      this.sendAnalyticsEventWithQueryInfo(
        "click_en_ir_detalle_marker_desde_listado",
        this.$route.query
      );

      this.routeToInmueblesDetailWithCachedData(itemClicked);
      // this.uiDetail.isShowed = true;
    },
    onMapMarkerClicked(referencia) {
      this.sendAnalyticsEventWithQueryInfo(
        "click_en_ir_detalle_marker_desde_mapa",
        this.$route.query
      );
      this.routeToInmueblesDetailWithoutCachedData(referencia);
    },
    onButtonVolverAlListadoClicked() {
      this.uiDetail.isShowed = false;
      this.uiList.isShowed = true;
    },
    onListPaginationChanged(newPagination) {
      this.list.options.paginationCurrentPage = newPagination.page;
      this.list.options.paginationResultsPerPage = newPagination.size;
      this.updateDataListWithExternalData();
    },
    onChipFilterTermDeleted(deletedTermFieldName) {
      // Enviamos al Analytics el evento (hay que hacer un apañito de datos de evento par aenviar sólo el termino que eliminamos)
      var query4EventInfo = {};
      query4EventInfo[deletedTermFieldName] = this.list.options.filterTerms[
        deletedTermFieldName
      ];

      this.sendAnalyticsEventWithQueryInfo(
        "click_en_eliminar_filtro",
        this.filterTerms2queryParams(query4EventInfo)
      );

      var newFilterTerms = this.$mdApp.utils.cloneObject(
        this.list.options.filterTerms
      );
      delete newFilterTerms[deletedTermFieldName];

      // this.updateListFilterTerms(newFilterTerms);
      this.$router.push(
        this.routerLinkTotViewWithFilter("/inmuebles", newFilterTerms)
      );
    },
    onFilterFullApplied(newFilterTerms) {
      this.list.options.paginationCurrentPage = 1; // Pq se ha reseteado el filtro
      this.updateListFilterTerms(newFilterTerms);

      this.sendAnalyticsEventWithQueryInfo(
        "click_en_aplicar_filtro",
        this.filterTerms2queryParams(newFilterTerms)
      );

      this.routeToInmuebles(newFilterTerms);
    },
    routeToInmuebles(newFilterTerms) {
      this.$router.push(
        this.routerLinkTotViewWithFilter("/inmuebles", newFilterTerms)
      );
    },
    routeToInmueblesDetailWithCachedData(itemData) {
      this.$router.push({
        name: "inmuebles-detail",
        params: {
          id: itemData.referencia,
          cachedItemData: itemData,
          prevRoute: this.$route,
          prevListData: this.list,
          prevMapData: this.map
        }
      });
    },
    routeToInmueblesDetailWithoutCachedData(referencia) {
      this.$router.push({
        name: "inmuebles-detail",
        params: {
          id: referencia,
          prevRoute: this.$route,
          prevListData: this.list,
          prevMapData: this.map
        }
      });
    },
    routerLinkTotViewWithFilter(path, filterTerms) {
      var queryParams = this.filterTerms2queryParams(filterTerms);

      return { path: path, query: queryParams };
    },
    filterTerms2queryParams(filterTerms) {
      var queryParams = {};

      // los filterTerms vienen en la forma {campo: {op:"=", value: "suelo"}} por eso hay que transformarlo
      Object.entries(filterTerms).forEach(([key, value]) => {
        queryParams[key.toLowerCase()] = value.value.toLowerCase();
      });

      return queryParams;
    },
    // TODO: Creo que este método sobra: probar a borrarlo
    onFullSearchSubmitted(searchFullText) {
      this.isFilterFullOpened = false;
      this.list.options.paginationCurrentPage = 1; // Pq se ha reseteado el filtro
      var filterTerms4SearchFull = {
        BUSQUEDA: {
          op: "=",
          value: searchFullText
        }
      };
      this.updateListFilterTerms(filterTerms4SearchFull);
      this.updateDataListWithExternalData();
      this.updateMapWithExternalData();
    },
    updateListFilterTerms(newFilterTerms) {
      this.list.options.filterTerms = {};

      // Los pasamos a formato objeto para manejarlo ya siempre en un unico formato
      if (newFilterTerms) {
        for (var currentTermName in newFilterTerms) {
          var currentTerm = newFilterTerms[currentTermName];

          var currentTermValue = currentTerm.value
            ? currentTerm.value
            : currentTerm;
          var currentTermOperator = currentTerm.op ? currentTerm.op : "=";

          this.list.options.filterTerms[currentTermName] = {
            op: currentTermOperator,
            value: currentTermValue
          };
        }

        // (old-vuemat) this.updateListFixedTermsWithProp();
      }
    },
    updateDataListWithExternalData() {
      var self = this;

      self.list.rows = [];

      // Dejamos la pantallita bien puestecita para que se vea bien los resultados
      this.isFilterFullOpened = false;
      this.scrollToTop();
      this.uiList.isLoading = true;

      this.$mdApp.dataAccess
        .readList(self.list.dataResourceName, self.list.options)
        .then(function(response) {
          if (Array.isArray(response.data)) {
            self.list.rows = response.data.map(function(item) {
              self.transformInmuebleListItemFromDataItem(item);
              return self.transformInmuebleListItemFromDataItem(item);
            });
            // self.list.rows = response.data;
          }
          self.uiList.isLoading = false;
          self.list.options.totalResultsNumber =
            response.headers["x-total-count"];
        });
    },
    updateMapWithExternalData() {
      var self = this;

      self.map.showMap = false;
      self.map.refsGeograficas = [];
      self.map.options = this.$mdApp.utils.cloneObject(self.list.options);
      self.map.options.filterTerms.enMapa = "S";
      self.map.options.paginationCurrentPage = 1;
      self.map.options.paginationResultsPerPage = null;

      this.$mdApp.dataAccess
        .readList(self.map.dataResourceName, self.map.options)
        .then(function(response) {
          // llenamos las rows poquito a poquito (para que se vea en las transiciones)
          if (Array.isArray(response.data)) {
            self.map.showMap = true;
            self.map.refsGeograficas = response.data;
            self.map.options.totalResultsNumber =
              response.headers["x-total-count"];
          }
        });
    },
    updateListPaginationWithDefaultOptions() {
      this.list.options.paginationResultsPerPage = this.defaultListOptions.paginationResultsPerPage;
      this.list.options.paginationCurrentPage = this.defaultListOptions.paginationCurrentPage;
      this.list.options.paginationOptions = this.$mdApp.utils.cloneObject(
        this.defaultListOptions.paginationOptions
      );
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    // transformInmuebleItemVideosFieldFromDataItem(item) {
    //   let videos = {};

    //   if (item.video_url) {
    //     let videosCSVFields = item.video_url.split(";");

    //     for (
    //       let position = 0;
    //       position < videosCSVFields.length;
    //       position = position + 2
    //     ) {
    //       let language = videosCSVFields[position];
    //       let videoId = videosCSVFields[position + 1];

    //       videos[language] = videoId;
    //     }
    //   }

    //   return videos;
    // },
    transformInmuebleItemVideosFieldFromDataItem(item) {
      let videos = {};

      if (item.video_url) {
        let videoId = item.video_url.replace("https://youtu.be/", "");
        videoId = videoId.replace("https://www.youtube.com/watch?v=", "");
        videos["es"] = videoId;
      }

      return videos;
    },
    transformInmuebleListItemFromDataItem(item) {
      let result = {
        tipoBien: item.tipo_inmueble,
        referencia: item.referencia_inmueble,
        nombrePromocion: item.nombre,
        provincia: item.provincia,
        superficie: item.mutiles ? item.mutiles + " m²" : "",
        // estado: item.estado.toLowerCase(),
        //mientras se implementa el estado
        estado: "consultar",
        edificabilidad: item.mconstruidos ? item.mconstruidos + " m²" : "",
        codigoPromocion: item.cod_promo.toString(),
        codigoUnidad: item.cod_prinex,
        municipio: item.municipio,
        oferta: item.oferta,
        observaciones: item.observaciones ? item.observaciones : "",
        direccionPostal: item.direccion_postal ? item.direccion_postal : "",
        isEnMapa: item.enmapa && item.enmapa === "S" ? true : false,
        precio: item.precio ? item.precio : "",
        tipoOferta: item.tipo_oferta ? item.tipo_oferta : "",
        poligono: item.poligono ? item.poligono : "",
        poligono2: item.poligono2 ? item.poligono2 : "",
        centroide: item.centroide ? item.centroide : "",
        fichaUrl: item.ficha_url ? item.ficha_url : "",
        videos: this.transformInmuebleItemVideosFieldFromDataItem(item)
      };

      return result;
    },
    queryParams2FilterTerms() {
      var queryParams = this.$mdApp.utils.cloneObject(this.$route.query);
      var newFilterTerms = {};

      for (var currentParamName in queryParams) {
        var currentParamValue = queryParams[currentParamName];

        if (currentParamValue) {
          // Si no viene vacío
          newFilterTerms[
            currentParamName.toUpperCase()
          ] = currentParamValue.toUpperCase();
        }
      }

      return newFilterTerms;
    }
  }
};
</script>

<style lang="scss">
@import "@/components/vue-material-app/default-variables";
@import "@material/layout-grid/mdc-layout-grid.scss";

.app-inmuebles-detail__pagination {
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 1px solid #dbe0e2; // Se pone aquí pq así se queda cuando se muestra filtro full

  .mdc-layout-grid__cell {
    line-height: 20px; // Para poder centrar verticalmente lo que va en el grid
  }

  .mdc-button {
    // margin-left: 8px; // Se alinea mejor en movil y se separa un poco en desktop -> chachi
    line-height: normal;
    vertical-align: middle;
    text-transform: none;
    height: 32px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-inmuebles-detail__pagination {
    padding-left: 5%;
    padding-right: 5%;
  }
}

@media (min-device-width: 1280px) {
  .app-inmuebles-detail__pagination {
    padding-left: 0;
    padding-right: 0;
    .mdc-layout-grid.mdc-layout-grid--height {
      width: 1200px;
    }
  }
}

.app-inmuebles-detail__data {
  padding-left: 0px;
  padding-right: 0px;
  background-color: #f7fafa;
}

.app-inmuebles-list__filter-simple {
  border-bottom: 1px solid #dbe0e2; // Se pone aquí pq así se queda cuando se muestra filtro full

  .mdc-layout-grid__cell {
    line-height: 56px; // Para poder centrar verticalmente lo que va en el grid
  }

  .mdc-chip-set {
    display: inline-block;
    line-height: normal;
    vertical-align: middle;
    .mdc-chip {
      margin-right: 1em;
      border: 1px solid rgba(0, 0, 0, 0.54);
      background-color: white;
    }
  }
  .mdc-button {
    margin-left: 8px; // Se alinea mejor en movil y se separa un poco en desktop -> chachi
    line-height: normal;
    vertical-align: middle;
    text-transform: none;
    height: 32px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-inmuebles-detail__data {
    padding-left: 5%;
    padding-right: 5%;
  }
}

@media (min-device-width: 1280px) {
  .app-inmuebles-detail__data {
    padding-left: 0;
    padding-right: 0;

    .mdc-layout-grid.mdc-layout-grid--height {
      width: 1200px;
    }
  }
}

.app-inmuebles-list__filter-simple__ver-en-mapa {
  display: inline-block;
  line-height: normal;
  vertical-align: middle;

  label {
    position: relative; // Se situaba un pelin raro, para que esté en linea con lo demás
    left: 0.5em;
    bottom: 2px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  /* Pq desktop para mdc es a partir de 840px (hay que cambiarlo) y le quitamos el padding para que se vean los filtros mejor */
  .app-inmuebles-list__filter-full {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (min-device-width: 1300px) {
  .app-inmuebles-list__filter-full {
    padding-left: 50px;
    padding-right: 50px;
  }
}

.app-inmuebles-list__results {
  // min-height: 1016px; comentaod pq no se situa bien footer
  background-color: #f7fafa;
  padding-top: 2em;
}

.app-inmuebles-list__results__title {
  height: 1em;
  font-size: 1.3em;
  font-weight: bolder;
  color: #607d8b;
}

.app-inmuebles-list__results__pagination {
  text-align: center;
  color: $mdc-theme-primary;
  * {
    font-size: 0.875em;
  }

  .mdc-icon-button.app-icon-button--pagination-arrow:not([disabled]) {
    margin-left: 1em;
    margin-right: 1em;
    width: 30px;
    height: 30px;
    padding-top: 8px;
    padding-right: 6px; // si no sale desviado no sé pq
    padding-bottom: 8px;
    padding-left: 8px;
    background: none;
    border-radius: 50%;
    border: 1px solid $mdc-theme-primary; // rgba(25, 118, 210, 1);
    color: $mdc-theme-primary; // rgb(25, 118, 210);
  }

  .mdc-icon-button.app-icon-button--number {
    bottom: 2px;
  }

  .mdc-icon-button.app-icon-button--number.app-icon-button--number--current {
    bottom: 0px; // Para situarlo bien del todo
    color: #455a64;
    font-weight: bolder;
    font-size: 1.2em;
  }
}
</style>
